import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ascendingBy } from '@shared/store/entity-state-store';
import { DeviceQueries } from '@/app/platform/platform-data/queries/types';
import { DeviceEntityStore } from '@/app/platform/platform-data/store/device.entity.store';
import { DeviceEntity } from '@/app/platform/platform-data/models/device.entity';

const byName = ascendingBy<DeviceEntity>('name');

@Injectable({ providedIn: 'root' })
export class DeviceStoreQueries implements DeviceQueries {
  constructor(protected store: DeviceEntityStore) {}

  readonly all$: Observable<DeviceEntity[]> = this.store.selectAll(byName);

  getAll(): DeviceEntity[] {
    return this.store.getAll(byName);
  }

  one$(id: string): Observable<DeviceEntity> {
    return this.store.selectEntity(id);
  }
}
